<div>
  @if (quotesLoading()) {
    <div class="flex justify-center p-4">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (quotesError()) {
    <div class="flex justify-center p-4">
      <p class="text-red-500">{{ errorText }}</p>
    </div>
  } @else {
    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="dataSource"
        [matSortActive]="currentSort.active"
        [matSortDirection]="currentSort.direction"
        matSort
        (matSortChange)="sortData($event)"
        class="w-full"
      >
        <ng-container matColumnDef="quoteId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Quote
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.quoteId }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Description
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.description }}</td>
        </ng-container>

        <ng-container matColumnDef="caNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            CA#
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.caNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-left">Quantity</th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.quantity }}</td>
        </ng-container>

        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Date Created
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.dateCreated | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Status
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.status.value }}
          </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Client
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.client }}</td>
        </ng-container>

        <ng-container matColumnDef="assignee">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Assignee
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">{{ element.assignee }}</td>
        </ng-container>

        <ng-container matColumnDef="dateUpdated">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="border-b p-4 text-left">
            Last Edited
          </th>
          <td mat-cell *matCellDef="let element" class="border-b p-4">
            {{ element.lastEdited | date: CONFIG.date.createdDateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="border-b p-4 text-right w-24"></th>
          <td mat-cell *matCellDef="let element" class="border-b p-4 text-right">
            <div class="invisible group-hover:visible flex items-center justify-end gap-2">
              <button
                mat-icon-button
                matTooltip="Edit Quote"
                [routerLink]="['/quotes', element.id, 'edit']"
                (click)="$event.stopPropagation()"
                class="text-gray-700"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [routerLink]="['/quotes', row.id, 'view']"
          class="hover:bg-gray-100 cursor-pointer quote-row group"
        ></tr>
      </table>
      <div
        *ngIf="!quotesLoading() && !quotesError() && dataSource.data.length === 0"
        class="text-center text-gray-500 py-8"
      >
        There are no records available.
      </div>
    </div>

    <ciwc-pagination
      [currentPage]="pageIndex"
      [pageSize]="pageSize"
      [totalItems]="totalMyQuotes"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)"
    ></ciwc-pagination>

    <!-- Hidden paginator for functionality -->
    <div class="hidden">
      <mat-paginator
        #paginator
        [length]="totalMyQuotes"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="handlePageEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </div>
  }
</div>
